class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    /* If the drawer hasn't been populated by renderContents, fetch cart sections first */
    if (!this._contentsRendered && !this._fetchingContents) {
      this._fetchingContents = true;
      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
      fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble')
        .then(r => r.json())
        .then(sections => {
          this._fetchingContents = false;
          this.classList.remove('is-empty');
          const drawerInner = this.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
          this.getSectionsToRender().forEach((section) => {
            const el = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (el && sections[section.id]) {
              el.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
            }
          });
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
          this._contentsRendered = true;
          this._doOpen();
          document.dispatchEvent(new CustomEvent('cartUpdated'));
        })
        .catch(() => { this._fetchingContents = false; this._doOpen(); });
      return;
    }

    this._doOpen();
  }

  _doOpen() {
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
      const cartDrawerItems = this.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      this._ensureGuarantee();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        if (!containerToTrapFocusOn) return;
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  _ensureGuarantee() {
    var gVid = window.guaranteeVariantId;
    if (!gVid || sessionStorage.getItem("upsellOptedOut") === "1") return;
    fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
      if (cart.item_count === 0) return;
      var inCart = cart.items.some(function(i) { return i.variant_id.toString() === gVid; });
      if (inCart) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(gVid), quantity: 1 }] })
      }).then(function() {
        var url = (typeof routes !== "undefined" && routes.cart_url ? routes.cart_url : "/cart") + "?section_id=cart-drawer";
        return Promise.all([fetch(url).then(function(r){return r.text();}), fetch("/cart.js").then(function(r){return r.json();})]);
      }).then(function(results) {
        var html = results[0], freshCart = results[1];
        var doc = new DOMParser().parseFromString(html, "text/html");
        var n, o;
        if ((n = doc.querySelector("cart-drawer-items")) && (o = document.querySelector("cart-drawer-items"))) o.innerHTML = n.innerHTML;
        if ((n = doc.querySelector(".drawer__footer")) && (o = document.querySelector(".drawer__footer"))) o.innerHTML = n.innerHTML;
        var cb = document.querySelector("#cart-upsell-checkbox");
        if (cb) cb.checked = true;
        var btn = document.getElementById("CartDrawer-Checkout");
        if (btn) btn.textContent = "Proc\u00e9der au paiement - " + (freshCart.total_price / 100).toFixed(2).replace(".", ",") + " EUR";
      }).catch(function() {});
    }).catch(function() {});
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this._contentsRendered = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this._contentsRendered = true;
    try {
      this.classList.remove('is-empty');
      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');
      this.productId = parsedState.id;

      if (!parsedState.sections) {
        console.warn('[cart-drawer] No sections in response, fetching cart…');
        fetch('/cart.js').then(r => r.json()).then(() => {
          return fetch('/?sections=cart-drawer,cart-icon-bubble');
        }).then(r => r.json()).then(sections => {
          this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (sectionElement && sections[section.id]) {
              sectionElement.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
            }
          });
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
          this.open();
          document.dispatchEvent(new CustomEvent('cartUpdated'));
        });
        return;
      }

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } else {
          console.warn('[cart-drawer] Missing section:', section.id, 'element:', !!sectionElement);
        }
      });

      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      requestAnimationFrame(() => {
        this.open();
        document.dispatchEvent(new CustomEvent('cartUpdated'));

      });
    } catch(e) {
      console.error('[cart-drawer] renderContents error:', e);
      this.open();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
